// extracted by mini-css-extract-plugin
module.exports = {"color":"_3JIFvjR","popover":"_10jVW18","picker":"_3VX6M72","used_color_board":"ZvvzhP-","used_color_board_title":"_20hhdSZ","used_color_cell":"qNr0HIP"};